import { render, staticRenderFns } from "./Rockstrom.vue?vue&type=template&id=4a984e94"
import script from "./Rockstrom.vue?vue&type=script&lang=js"
export * from "./Rockstrom.vue?vue&type=script&lang=js"
import style0 from "./Rockstrom.vue?vue&type=style&index=0&id=4a984e94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports